import React from 'react';
import CardBase from './CardBase';
import PropTypes from 'prop-types';

const Secondary = ({
  tag,
  children,
  loading,
  loadingHeight,
  flat,
  noContentSpace,
  header,
  headerRight,
  boxShadow,
  borderRadius,
}) => {
  return (
    <CardBase
      tag={tag}
      borderColor="purple"
      backgroundColor="purple"
      headerColor="white"
      loading={loading}
      loadingHeight={loadingHeight}
      flat={flat}
      noContentSpace={noContentSpace}
      header={header}
      headerRight={headerRight}
      boxShadow={boxShadow}
      borderRadius={borderRadius}
    >
      {children}
    </CardBase>
  );
};

Secondary.propTypes = {
  tag: PropTypes.string,
  children: PropTypes.node.isRequired,
  loading: PropTypes.bool,
  loadingHeight: PropTypes.number,
  flat: PropTypes.string,
  noContentSpace: PropTypes.bool,
  header: PropTypes.node,
  headerRight: PropTypes.node,
  boxShadow: PropTypes.string,
  borderRadius: PropTypes.string,
};

export default Secondary;
